module.exports = {
  title: '收款账户设置',
  route: {
    path: '/merchant-manage',
    children: {
      path: 'collect-money-accounts-details',
    },
  },
};
